function gmapInit() {
  if($("#map-canvas").length === 0){
    return false;
  }

  var lat = 48.424468 ;
  var lng = -123.364606;
  var address = ($("#map-canvas").data('address') ? $("#map-canvas").data('address') : '');

  if($("#map-canvas").data('lat') && $("#map-canvas").data('lng')){
    lat = $("#map-canvas").data('lat');
    lng = $("#map-canvas").data('lng');
  }

  var geocoder = new google.maps.Geocoder();
  var myLatlng = new google.maps.LatLng(lat, lng);
  var mapOptions = {
    zoom: 15,
    center: myLatlng,
    panControl: false,
    zoomControl: true,
    scaleControl: false,
    scrollwheel: false,
    //styles:[{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"hue":"#0066ff"},{"saturation":74},{"lightness":100}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"off"},{"weight":0.6},{"saturation":-85},{"lightness":61}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"simplified"},{"color":"#5f94ff"},{"lightness":26},{"gamma":5.86}]}]
  };

  if(Modernizr.touch){
    mapOptions.draggable = false;
  }

  var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

  var content = '';

  if(address) {
    content += ($("#map-canvas").data('image') ? '<img src="' + $("#map-canvas").data('image') + '"><br>' : '');
    content += '<div style="text-align:center;"><b>' + address + '</b>';
    content += '<br><a target="_blank" href="https://www.google.ca/maps/place/' + address.split(' ').join('+') + '">View Larger</a>';
    content += '</div>';
  }

  var infowindow = new google.maps.InfoWindow({
    content: content,
    size: new google.maps.Size(150, 50)
  });

  var pin = {
    path: 'M24,64S0,37.25,0,24a24,24,0,0,1,48,0C48,37.25,24,64,24,64ZM24,8A16,16,0,1,0,40,24,16,16,0,0,0,24,8Zm0,24a8,8,0,1,1,8-8A8,8,0,0,1,24,32Z',
    fillColor: '#195ac5',
    fillOpacity: 1,
    scale: 1,
    strokeWeight: 0,
    size: new google.maps.Size(33, 44),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(20, 50)
  };

  var marker = new google.maps.Marker({
      position: myLatlng,
      map: map,
      icon: pin
  });

  var currCenter = map.getCenter();
  google.maps.event.addDomListener(window, 'resize', function() {
    map.setCenter(currCenter);
  });

  google.maps.event.addDomListener(window, 'orientationchange', function() {
    map.setCenter(currCenter);
  });

  google.maps.event.addListener(marker, 'click', function() {
    infowindow.open(map, marker);
  });
}
